export function getBrowserInfo() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') {
    return {};
  }
  const ua = navigator.userAgent || '';
  return {
    userAgent: ua,
    browser: detectBrowser(ua),
    os: detectOs(ua),
    platform: navigator.platform || '',
    language: navigator.language || '',
    screen: window.screen ? `${window.screen.width}x${window.screen.height}` : '',
  };
}

function detectBrowser(ua) {
  if (/Edg\/(\d+)/.test(ua)) return `Edge ${RegExp.$1}`;
  if (/Chrome\/(\d+)/.test(ua) && !/Chromium\/(\d+)/.test(ua)) return `Chrome ${RegExp.$1}`;
  if (/Firefox\/(\d+)/.test(ua)) return `Firefox ${RegExp.$1}`;
  if (/Version\/(\d+).*Safari\//.test(ua)) return `Safari ${RegExp.$1}`;
  return 'Unknown';
}

function detectOs(ua) {
  if (/Windows NT 10/.test(ua)) return 'Windows 10';
  if (/Windows NT 11/.test(ua)) return 'Windows 11';
  if (/Mac OS X (\d+[._]\d+)/.test(ua)) return `macOS ${RegExp.$1.replace('_', '.')}`;
  if (/Android (\d+)/.test(ua)) return `Android ${RegExp.$1}`;
  if (/iPhone OS (\d+)/.test(ua)) return `iOS ${RegExp.$1}`;
  if (/Linux/.test(ua)) return 'Linux';
  return 'Unknown';
}
